function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Switch } from 'react-router-dom';
import Route from '@signiapp/core/components/Route.js';
import Menu from "./components/contacts/Menu";
import Contacts from "./pages/Contacts";
import DelegatedContacts from "./pages/DelegatedContacts";
import ContactList from "./pages/ContactList";
import ContactForm from "./pages/ContactForm";
import Import from "./pages/Import";
import Snackbar from "./components/common/Snackbar";
import LoadingOverlay from "./components/common/LoadingOverlay";
import path from 'path';
import { getContactsUsers } from "./store/actions/contacts";
import { getContactLists } from "./store/actions/contactLists";
import { getDictionary, initializeSignatureSettings } from "./store/actions/app";
import "./styling/App.css";
import "./styling/Global.css";
import { session as sessionHelper } from '@signiapp/helpers';
import { LoginRequired } from '@signiapp/helpers/errors';

var App = function App(props) {
  var match = props.match,
      location = props.location,
      session = props.session,
      language = props.language,
      groups = props.groups,
      features = props.features;
  var dispatch = useDispatch();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  if (sessionHelper.isAuthenticated !== true) {
    throw LoginRequired();
  }

  useEffect(function () {
    var startup = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch({
                  type: 'SET_USER_ID',
                  userId: session.user.userId
                });

              case 3:
                _context.next = 5;
                return dispatch({
                  type: 'SET_LANGUAGE',
                  language: language
                });

              case 5:
                _context.next = 7;
                return dispatch(getDictionary(language));

              case 7:
                if (!(language !== 'en')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return dispatch(getDictionary('en'));

              case 10:
                _context.next = 12;
                return dispatch(initializeSignatureSettings());

              case 12:
                _context.next = 14;
                return dispatch(getContactsUsers());

              case 14:
                _context.next = 16;
                return dispatch(getContactLists());

              case 16:
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 21:
                setLoading(false);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 18]]);
      }));

      return function startup() {
        return _ref.apply(this, arguments);
      };
    }();

    startup();
  }, []);
  var basename = match.path;
  return /*#__PURE__*/React.createElement("div", {
    className: "app-container"
  }, loading && /*#__PURE__*/React.createElement(LoadingOverlay, {
    background: 'white',
    zIndex: 10
  }), /*#__PURE__*/React.createElement(Snackbar, null), /*#__PURE__*/React.createElement(Menu, null), /*#__PURE__*/React.createElement(Switch, {
    location: location
  }, /*#__PURE__*/React.createElement(Route, {
    path: path.join(basename, 'new'),
    component: ContactForm
  }), /*#__PURE__*/React.createElement(Route, {
    path: path.join(basename, 'edit', ':id'),
    component: ContactForm
  }), /*#__PURE__*/React.createElement(Route, {
    path: path.join(basename, 'import'),
    component: Import
  }), /*#__PURE__*/React.createElement(Route, {
    path: path.join(basename, 'list', ':id'),
    component: ContactList
  }), /*#__PURE__*/React.createElement(Route, {
    path: path.join(match.path, ':id'),
    component: DelegatedContacts
  }), /*#__PURE__*/React.createElement(Route, {
    path: basename,
    component: Contacts
  })));
};

export default App;